import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipeModule } from 'src/app/shared/pipe/pipe.module';
import { ListStatusComponent } from './list-status.component';


@NgModule({
  declarations: [ListStatusComponent],
  exports: [ListStatusComponent],
  imports: [
    CommonModule,
    PipeModule
  ]
})
export class ListStatusModule { }
